$shm_showcase_demo_paginator $mol_view
	sub /
		<= Top $shm_paginator
			page? <=> page? 0
			total 1080
		<= Bottom $shm_paginator
			page? <=> page?
			total 1080
